import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TransfersPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransfersPage";
import Classes, { Account } from "model";

export default function CaptureLoanTransferDateSelected(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const loanAccount = Account.getDefaultBrandedAccountByType("loan");

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], checkingAccount)
        .update([ "transfer", "to" ], loanAccount)
        .update([ "transfer", "paymentOption" ], "Payment Due")
        .update([ "transfer", "schedule" ], "Recurring")
        .update([ "transfer", "frequency" ], "Monthly")
        .update([ "transfer", "duration" ], "No End Date")
        .update([ "transfer", "startDate" ], BCMSDate.init())
        .update([ "transfer", "estimatedDeliveryDate" ], BCMSDate.init())
        .submit();

    const ui = getDefaultPageUI(data.transfer, globalController);

    return <TransfersPage data={ data } ui={ ui } />
}